<template>
  <div class="rootTable">
    <ul v-for="item in UserList" :key="item.qZNM">
      <li>
        <Cell v-on:click.native="Details(item)" is-link style="height: 60px;">
          <div class="mint-cell-title"
               style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
            <label class="mint-checklist-label"
                   style="text-align: left;">
              <div style="float: left;margin-top: 0.25rem">
                <avatar slot="icon" class="avatar" username="Birth Circle"
                        :src="item.avatarUrl"
                        :size="48">
                </avatar>
              </div>
              <div style="float: left;margin-top: 0.5rem;margin-left: 0.6rem">
                <div>
                  <span style="color: green;font-size: 1.2rem">{{ item.userName }}</span>
                </div>
                <div>
                  <span style="font-size: 0.8rem">平台帐号：</span>
                  <span style="font-size: 0.8rem;color: blue">{{ item.account }}</span>
                </div>
              </div>
            </label>
          </div>
        </Cell>
      </li>
    </ul>
  </div>
</template>

<script>
import {Cell} from 'mint-ui';
import Avatar from 'vue-avatar'

export default {
  name: "CircleUser",
  data() {
    return {
      qznm: null,
      UserList: [],
      token: localStorage.getItem('token'),
      getCircleUserListUrl: '/api/circle/getCircleUserList',
    }
  },
  components: {
    Cell, Avatar
  },
  mounted() {
    if (this.$route.query.qznm !== undefined) {
      this.qznm = this.$route.query.qznm
      this.getCircleUserList()
    } else {
      this.$router.go(-1)
    }
  },
  methods: {
    Details(item) {
      console.log(item)
    },
    async getCircleUserList() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getCircleUserListUrl,
        params: {qznm: that.qznm},
        headers: {token: that.token}
      }).then((response) => {
        if (response.data.result) {
          that.UserList = response.data['responseData']
          that.UserList.forEach(item => {
            if (item.avatarUrl === null) {
              const data = require('/public/config/data.json')
              item.avatarUrl = data['defaultAvatarUrl']
              item.hightAvatarUrl = data['defaultAvatarUrl']
            }
          })
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.rootTable {
  //margin-top: -1rem;
  width: 100%;
  height: 100%;

  ul {
    list-style-type: none;

    li {
      //margin-left: -2.5rem;
      height: 55px;
    }
  }
}
</style>
